import { render, staticRenderFns } from "./MapFrame.vue?vue&type=template&id=23792fea&scoped=true"
import script from "./MapFrame.vue?vue&type=script&lang=js"
export * from "./MapFrame.vue?vue&type=script&lang=js"
import style0 from "./MapFrame.vue?vue&type=style&index=0&id=23792fea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23792fea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
